import { orderSummaryPage } from 'features/order-tracker/router/path-constants';

export const isSummaryPage = (): boolean => window.location.href.includes(orderSummaryPage);

export const getHostname = (): string => {
  const REACT_APP_AEM_HEADLESS_HOST = import.meta.env.VITE_AEM_HEADLESS_HOST || window.location.origin;
  return REACT_APP_AEM_HEADLESS_HOST;
};
